import React from 'react';

const LogicaContext = React.createContext({
  data: null,
  onLogin: () => null,
  ticket: null,
  onLogout: () => null,
  widgetMode: '',
  setWidgetMode: () => null,
  widgetURI: '',
  documentsOnValidation: [],
  addDocumentToValidation: () => null,
  removeDocumentOnValidation: () => null,
});

export default LogicaContext;
